











import { Component, Mixins, Emit, Prop } from 'vue-property-decorator'
import BaseComponent from '@/tcw/components/BaseComponent'

@Component
export default class Logout extends Mixins(BaseComponent) {
  @Prop({ default: false })
  private open!: boolean
  @Emit('update:open')
  private updateOpen(): void {
    /** */
  }

  private async logout() {
    try {
      await this.$tcw.session.logout()
      this.$tcw.session.clear()
      this.$tcw.$store.basic.clearCurrentDate()
      this.$router.push('/')

      this.$tcw.message({
        type: 'success',
        message: 'ログアウトしました'
      })
    } catch (e) {
      // ログアウト失敗
      this.$tcw.$store.errors.setError(e)
    }
  }
}
